// extracted by mini-css-extract-plugin
export default {"container":"SentEmailSubject_container__-pcMr","subject":"SentEmailSubject_subject__o-uXH","subjectText":"SentEmailSubject_subjectText__1w+aw"};